<template>
<div v-tippy="content?{}:{trigger:'manual'}" :content="content">
	<strong>{{prefix}} {{ v }} {{suffix}}</strong>
	<div v-if="!noOldValue" class="delta "
	     :class="{
				'huge-delta': big,
				'delta-zero':value==oldValue,
				'delta-up':value>oldValue,
	      'delta-down':value<oldValue}">{{perDiff(value, oldValue)}} %</div>

</div>
</template>

<script>
import numbers from "@/helpers/numbers";

export default {
name: "ValueDiff",
	props: {
		big:{
			default: false,
			type: Boolean,
		},
		isMoney:{
			default: false,
			type: Boolean,
		},
		value:{
			default: 0,
			// type: Number,
		},
		oldValue:{
			default: 0,
			// type: Number,
		},
		suffix:{
			default: "",
			type: String,
		},
		prefix:{
			default: "",
			type: String
		},
		digits: {
			type: Number,
			default: 0,
		},
		perDigits: {
			type: Number,
			default: 2,
		},
		noOldValue: {
			type: Boolean,
			default: false,
		}
	},
	computed:{
		v(){
			try {
				let _v = this.value.toFixed(this.digits);
				return this.isMoney ? this.formatPrice(_v) : _v;
			} catch (e) {
				return this.value || 0;
			}
		},
		oldV(){
			let _v = this.oldValue.toFixed(this.digits);
			return this.isMoney ? this.formatPrice(_v) : _v;
		},
		content() {
			if (this.noOldValue) return null;// `${this.prefix} <b>${this.v}</b> ${this.suffix}`

			return '<b>'+this.perDiff(this.value, this.oldValue) + '%</b> change, was <b>'+
					this.prefix+this.oldV+this.suffix+'</b> previous period.';
		}
	},
	methods:{
		formatPrice(value) {
			let val = (value/1).toFixed(2)//.replace('.', ',')
			return numbers.numberWithCommas(val)
		},
		perDiff(value, oldValue){
			let difference = (value-oldValue);

			if (!oldValue && value) return (100).toFixed(this.perDigits); // use current value as the change value.

			let per = difference/oldValue*100;

			return this.notNaN(per).toFixed(this.perDigits);
		},
		notNaN(n) {
			if(isNaN(n)) return 0;
			return n;
		},
	}
}
</script>

<style scoped>

</style>
